export function showAlert(): void {
  $('.alert-wrapper').fadeIn();

  $('.js-alert-close').click(function(){
    $('.alert-wrapper').fadeOut();
  });
}
